import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import Dialog from '../../services/Dialogs'

const ModalEditarInformacionSucursales = ( params : any ) => {


  const { show, handleClose, sucursal_seleccionada } = params


const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const dialog = new Dialog();





  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({

          nombre_sucursal : yup.string().required(mensajes_validacion_generico),
          direccion : yup.string().required(mensajes_validacion_generico),
          telefono : yup.string().required(mensajes_validacion_generico),
          email : yup.string(),
          colonia : yup.string().required(mensajes_validacion_generico),
          cp : yup.string().required(mensajes_validacion_generico),

          idestado : yup.number().required(mensajes_validacion_generico),

          meta_mensual_estrategias : yup.number().required(mensajes_validacion_generico),

  });



const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `sucursal/${sucursal_seleccionada.uuid}` , { ...registro })

        if(res_){
          toast.warning('La información de la Sucursal se Actualizó')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Editar Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(sucursal_seleccionada)
          }






    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

            nombre_sucursal : sucursal_seleccionada.nombre_sucursal,
            direccion : sucursal_seleccionada.direccion,
            telefono : sucursal_seleccionada.telefono,
            email : sucursal_seleccionada.email,
            colonia : sucursal_seleccionada.colonia,
            cp : sucursal_seleccionada.cp,
            idestado : sucursal_seleccionada.idestado.id,


            meta_mensual_estrategias : sucursal_seleccionada.meta_mensual_estrategias,

      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


          <h5>Meta de la Sucursal</h5>

            <Form.Group className="mb-3" controlId="meta_mensual_estrategias">
              <Form.Label>Cantidad de Trámites para la Sucursal</Form.Label>
              <Form.Control
                required
                name="meta_mensual_estrategias"
                value={values.meta_mensual_estrategias}
                onChange={(e)=>{ setFieldValue('meta_mensual_estrategias', (e.target.value) ) }}
                isInvalid={!!errors.meta_mensual_estrategias}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>



          <h5>Información de la Sucursal</h5>

            <Form.Group   className="mb-3" controlId="nombre_sucursal">
              <Form.Label>Nombre de la Sucursal</Form.Label>
              <Form.Control
                required
                name="nombre_sucursal"
                value={values.nombre_sucursal}
                onChange={(e)=>{ setFieldValue('nombre_sucursal', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.nombre_sucursal}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>




            <div className="row">
              <div className="col-5">
                  <Form.Group   className="mb-3" controlId="telefono">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      required
                      name="telefono"
                      value={values.telefono}
                      onChange={(e)=>{ setFieldValue('telefono', (e.target.value || "").toUpperCase() ) }}
                      isInvalid={!!errors.telefono}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
              </div>
              <div className="col-7">
                  <Form.Group   className="mb-3" controlId="email">
                    <Form.Label>Correo Electrónico</Form.Label>
                    <Form.Control
                      required
                      name="email"
                      value={values.email}
                      onChange={(e)=>{ setFieldValue('email', (e.target.value) ) }}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
              </div>
            </div>






            <Form.Group className="mb-3" controlId="idestado">
              <Form.Label>Estado</Form.Label>
              <Form.Select required name="idestado" value={values.idestado} onChange={(e)=>{ setFieldValue('idestado', e.target.value ) }} isInvalid={!!errors.idestado}>
                <option disabled={values.idestado!==''} value="">SELECCIONA UN ESTADO</option>

                <option value={1}>AGUASCALIENTES</option>
                <option value={2}>BAJA CALIFORNIA</option>
                <option value={3}>BAJA CALIFORNIA SUR</option>
                <option value={4}>CAMPECHE</option>
                <option value={5}>CHIAPAS</option>
                <option value={6}>CHIHUAHUA</option>
                <option value={7}>COAHUILA DE ZARAGOZA</option>
                <option value={8}>COLIMA</option>
                <option value={9}>DURANGO</option>
                <option value={10}>GUANAJUATO</option>
                <option value={11}>GUERRERO</option>
                <option value={12}>HIDALGO</option>
                <option value={13}>JALISCO</option>
                <option value={14}>MÉXICO</option>
                <option value={15}>MICHOACÁN DE OCAMPO</option>
                <option value={16}>MORELOS</option>
                <option value={17}>NAYARIT</option>
                <option value={18}>NUEVO LEÓN</option>
                <option value={19}>OAXACA</option>
                <option value={20}>PUEBLA</option>
                <option value={21}>QUERÉTARO ARTEAGA</option>
                <option value={22}>QUINTANA ROO</option>
                <option value={23}>SAN LUIS POTOSÍ</option>
                <option value={24}>SINALOA</option>
                <option value={25}>SONORA</option>
                <option value={26}>TABASCO</option>
                <option value={27}>TAMAULIPAS</option>
                <option value={28}>TLAXCALA</option>
                <option value={29}>VERACRUZ</option>
                <option value={30}>YUCATÁN</option>
                <option value={31}>ZACATECAS</option>
                <option value={32}>CIUDAD DE MÉXICO</option>


              </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid"> {errors.idestado} </Form.Control.Feedback>
            </Form.Group>



 



            <Form.Group   className="mb-3" controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                as="textarea"
                required
                name="direccion"
                value={values.direccion}
                onChange={(e)=>{ setFieldValue('direccion', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.direccion}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>




            <div className="row">
              <div className="col-8">
                  <Form.Group   className="mb-3" controlId="colonia">
                    <Form.Label>Colonia</Form.Label>
                    <Form.Control
                      required
                      name="colonia"
                      value={values.colonia}
                      onChange={(e)=>{ setFieldValue('colonia', (e.target.value || "").toUpperCase() ) }}
                      isInvalid={!!errors.colonia}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
              </div>
              <div className="col-4">
                  <Form.Group   className="mb-3" controlId="cp">
                    <Form.Label>Código Postal</Form.Label>
                    <Form.Control
                      required
                      name="cp"
                      value={values.cp}
                      onChange={(e)=>{ setFieldValue('cp', (e.target.value || "").toUpperCase() ) }}
                      isInvalid={!!errors.cp}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
              </div>
            </div>

 


        </Form>
      )}
    </Formik>





        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalEditarInformacionSucursales;